export default __webpack_public_path__ + "static/media/animation_640_krze75vw.f471e9ff.gif";